(() => {
  const elementsWithin = (root, selector) => {
    const elements = [];
    if (root instanceof Element && root.matches(selector)) elements.push(root);
    return elements.concat(Array.from(root.querySelectorAll?.(selector) || []));
  };

  const initTabs = (section) => {
    if (section.dataset.arcanaTabsReady === 'true') return;
    section.dataset.arcanaTabsReady = 'true';

    section.querySelectorAll('[data-arcana-tabs]').forEach((tabsRoot) => {
      const tabs = Array.from(tabsRoot.querySelectorAll('[data-arcana-tab]'));
      const panels = Array.from(tabsRoot.querySelectorAll('[data-arcana-panel]'));

      const activate = (tab, focus = false) => {
        if (!tab) return;
        const selectedId = tab.dataset.arcanaTab;

        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.arcanaPanel !== selectedId;
        });

        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activate(tabs[nextIndex], true);
        });
      });
    });
  };

  const initGallery = (section) => {
    if (section.dataset.arcanaGalleryReady === 'true') return;
    section.dataset.arcanaGalleryReady = 'true';

    const track = section.querySelector('[data-arcana-gallery-track]');
    const items = Array.from(section.querySelectorAll('[data-arcana-gallery-item]'));
    const previous = section.querySelector('[data-arcana-gallery-prev]');
    const next = section.querySelector('[data-arcana-gallery-next]');
    const current = section.querySelector('[data-arcana-gallery-current]');
    let activeIndex = 0;

    const updateCounter = () => {
      if (!track || !current || items.length === 0) return;
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(trackCenter - itemCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      current.textContent = String(activeIndex + 1);
    };

    const goTo = (index) => {
      if (items.length === 0) return;
      activeIndex = (index + items.length) % items.length;
      items[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (current) current.textContent = String(activeIndex + 1);
    };

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    track?.addEventListener('scroll', updateCounter, { passive: true });

    const lightbox = section.querySelector('[data-arcana-lightbox]');
    const lightboxImage = lightbox?.querySelector('figure img');
    const lightboxCaption = lightbox?.querySelector('figcaption');
    const closeButton = lightbox?.querySelector('[data-arcana-lightbox-close]');
    let trigger = null;

    const closeLightbox = () => {
      if (!lightbox?.open) return;
      lightbox.close();
      trigger?.focus();
    };

    section.querySelectorAll('[data-arcana-lightbox-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!lightbox || !lightboxImage || !lightboxCaption) return;
        const image = button.querySelector('img');
        const caption = button.closest('figure')?.querySelector('figcaption');
        if (!image) return;

        trigger = button;
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt || '';
        lightboxCaption.textContent = caption?.textContent.replace(/\s+/g, ' ').trim() || '';

        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else lightbox.setAttribute('open', '');
      });
    });

    closeButton?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeLightbox();
    });
  };

  const initAll = (root = document) => {
    elementsWithin(root, '[data-arcana-formats-section]').forEach(initTabs);
    elementsWithin(root, '[data-arcana-gallery-section]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  if (!window.__arcanaPageEventsBound) {
    window.__arcanaPageEventsBound = true;

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const formats = event.target.closest('[data-arcana-formats-section]');
      const tab = formats?.querySelector(`[data-arcana-tab="${event.detail.blockId}"]`);
      tab?.click();

      const gallery = event.target.closest('[data-arcana-gallery-section]');
      const galleryItem = gallery?.querySelector(`[data-shopify-editor-block*="${event.detail.blockId}"]`);
      galleryItem?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }
})();
